module.exports = __webpack_public_path__ + "img/normal_multiplier_2.715fb3f8.png";